import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
    ajaxFeedbackFilter,
    ajaxFeedbackStatusFilter,
    ajaxFeedbackFilterDates,
    getStarsJSX,
    setFeedbackStatus,
    setCustomTimeframe,
    setOtherFilter,
    updateModalContent
} from "./redux/FeedbackRedux";
import Loading from "./Loading";
import GradedSmiley from "./GradedSmiley";

class StatsBar extends React.Component {
    constructor() {
        super();
        this.state = {
            send_email: window.user_email ?? "",
        };
    }

    handleClick(event) {
        var timeframe = event.target.id;
        var status = this.props.status;
        var ids = this.props.business_id ?? null;
        if (this.props.businesses) {
            ids = [];
            for (var i in this.props.businesses) {
                ids.push(this.props.businesses[i].business_id);
            }
        }
        this.props.dispatch(
            ajaxFeedbackStatusFilter(
                this.props.state,
                null,
                timeframe
            )
        );
    }

    handleDownloadClick(event) {
        var ids = [];
        for (var i in this.props.businesses) {
            ids.push(this.props.businesses[i].business_id);
        }
        console.log(this.props.businesses);
        var data = {
            user_id: this.props.current_user,
            business_ids: ids,
            timeframe: this.props.timeframe,
            status: this.props.status,
            timezone: this.props.businesses[0].call_at_timezone,
            dept_ids: this.props.department_ids,
            region: this.props.region ? this.props.region.id : null,
            tfstart: this.props.timeframe_prev,
            tfend: this.props.timeframe_next,
        };
        var url = "/dashboard/report/download-pdf?";
        for (var d in data) {
            url += d;
            url += "=";
            url += data[d];
            url += "&";
        }

        console.log(url);
        //$("#pdf-generating").removeClass('hide');

        alert(__("PDF File is being generated. It will be downloaded automatically once it is done processing."));

        document.location = url;
    }

    handleExportButtonClick() {
        const modal_id = "download_XLS";
        const modal_title = __('Download XLS Export');
        const modal_body = "exportXls";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "export_xls_send_btn";
        const button_2_text = __("Send Report");
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    handleDateTimeChange(event) {
        var prev = jQuery(".previous-date").val();
        var next = jQuery(".next-date").val();
        var timeframe = { prev: prev, next: next };
        var ids = this.props.business_id;
        if (timeframe.prev && timeframe.next) {
            this.props.dispatch(setCustomTimeframe(timeframe));
            if (this.props.region) {
                this.props.dispatch(
                    ajaxFeedbackStatusFilter(
                        this.props.state,
                        null,
                        "custom",
                        ids,
                        timeframe
                    )
                );
            } else {
                this.props.dispatch(
                    ajaxFeedbackStatusFilter(
                        this.props.state,
                        null,
                        "custom",
                        timeframe
                    )
                );
            }
        }
    }

    handleStatusClick(event) {
        event.preventDefault();
        var prev = jQuery(".previous-date").val();
        var next = jQuery(".next-date").val();
        console.log("status click");
        if (prev && next) {
            var dateobject = { prev: prev ?? null, next: next ?? null };
        } else {
            var dateobject = null;
        }
        var timeframe = this.props.timeframe;
        var status = event.target.id;
        var ids = this.props.business_id;
        if (this.props.businesses) {
            ids = [];
            for (var i in this.props.businesses) {
                ids.push(this.props.businesses[i].business_id);
            }
        }
        this.props.dispatch(
            ajaxFeedbackStatusFilter(
                this.props.state,
                status,
            )
        );
    }

    handleOtherClick(event) {
        event.preventDefault();

        var other_filter = event.target.id;
        if (!other_filter) {
            var is_a_star = jQuery(event.target).hasClass("rating-star");
            if (is_a_star) {
                other_filter = "ratethisbiz";
            }
        }
        if (other_filter == "ratethisbiz_span") {
            other_filter = "ratethisbiz";
        }

        this.props.dispatch(setOtherFilter(other_filter));
        this.props.dispatch(setFeedbackStatus("All"));

        this.props.dispatch(
            ajaxFeedbackStatusFilter(
                this.props.state,
                "All",
                null,
                null,
                other_filter
            )
        );
    }

    handleChangeSendEmail(event) {
        this.setState({ ...this.state, send_email: event.target.value });
    }

    componentDidMount() {
        jQuery('.download-email').hide();
        $('[data-toggle="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: "bottom",
                container: 'body',
                boundary: 'window'
            });
        });
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').each(function () {
            var title = jQuery(this).attr("data-original-title");
            jQuery(this).attr("data-title", title);
        });
    }

    render() {
        if (this.props.totals.AIScore < 50) {
            var AIScore = "text-danger";
        }
        if (this.props.totals.AIScore > 50 && this.props.totals.AIScore < 65) {
            var AIScore = "text-warning";
        }
        if (this.props.totals.AIScore > 65) {
            var AIScore = "text-success";
        }

        if (this.props.totals.smiley_score < 50) {
            var SmileyScore = "text-danger";
        }
        if (
            this.props.totals.smiley_score > 50 &&
            this.props.totals.smiley_score < 65
        ) {
            var SmileyScore = "text-warning";
        }
        if (this.props.totals.smiley_score > 65) {
            var SmileyScore = "text-success";
        }

        if (this.props.totals.smiley_score >= 85) {
            var color = "#01de1c";
        } else if (
            this.props.totals.smiley_score >= 70 &&
            this.props.totals.smiley_score < 85
        ) {
            var color = "#33f502";
        } else if (
            this.props.totals.smiley_score >= 55 &&
            this.props.totals.smiley_score < 70
        ) {
            var color = "#8cc704";
        } else if (
            this.props.totals.smiley_score >= 45 &&
            this.props.totals.smiley_score < 55
        ) {
            var color = "#888888";
        } else if (
            this.props.totals.smiley_score >= 30 &&
            this.props.totals.smiley_score < 45
        ) {
            var color = "#ffcf08";
        } else if (
            this.props.totals.smiley_score >= 15 &&
            this.props.totals.smiley_score < 30
        ) {
            var color = "#fe0100";
        } else if (
            this.props.totals.smiley_score >= 0 &&
            this.props.totals.smiley_score < 15
        ) {
            var color = "#b30101";
        }

        return (
            <div className="col-xl-12">
                <div className="card card-mtd">
                    <Loading location={"stats"} />
                    <div className="title-row d-flex align-items-center">
                        <div className="card-title tab">
                            <div className="dropdown">
                                <button className="btn btn-card dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.props.timeframe === "monthToDate" ? __("Month to Date") : ""}
                                    {this.props.timeframe === "weekToDate" ? __("Week to Date") : ""}
                                    {this.props.timeframe === "today" ? __("Today") : ""}
                                    {this.props.timeframe === "yesterday" ? __("Yesterday") : ""}
                                    {this.props.timeframe === "lifetime" ? __("Lifetime") : ""}
                                    {this.props.timeframe === "last30" ? __("Last 30 Days") : ""}
                                    {this.props.timeframe === "custom" ? __("Custom Timeframe") : ""}
                                </button>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="today"
                                        href="#"
                                    >
                                        {__('Today')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="yesterday"
                                        href="#"
                                    >
                                        {__('Yesterday')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="weekToDate"
                                        href="#"
                                    >
                                        {__('Week to Date')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="monthToDate"
                                        href="#"
                                    >
                                        {__('Month to Date')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="last30"
                                        href="#"
                                    >
                                        {__('Last 30 Days')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="lifetime"
                                        href="#"
                                    >
                                        {__('Lifetime')}
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        onClick={this.handleClick.bind(this)}
                                        id="custom"
                                        href="#"
                                    >
                                        {__('Custom')}
                                    </a>
                                </div>
                            </div>
                        </div>

                        {this.props.timeframe == "custom" && (
                            <div className="card-title">
                                <input
                                    className="form-control previous-date"
                                    defaultValue={this.props.timeframe_prev}
                                    onChange={this.handleDateTimeChange.bind(
                                        this
                                    )}
                                    type="date"
                                    required
                                />
                            </div>
                        )}
                        {this.props.timeframe == "custom" && (
                            <div className="card-title">{__('To')}</div>
                        )}
                        {this.props.timeframe == "custom" && (
                            <div className="card-title">
                                <input
                                    className="form-control next-date"
                                    defaultValue={this.props.timeframe_next}
                                    onChange={this.handleDateTimeChange.bind(
                                        this
                                    )}
                                    type="date"
                                    required
                                />
                            </div>
                        )}

                        {this.props.businesses && (
                            <div className="card-title ml-auto">
                                <a
                                    className="btn btn-outline-primary btn-sm text-primary"
                                    onClick={this.handleDownloadClick.bind(
                                        this
                                    )}
                                >
                                    <i className="fas fa-file-download mr-1"></i>{" "}
                                    {__('Download Report PDF')}
                                </a>
                            </div>
                        )}

                        <div className="card-title">
                            <a
                                className="btn btn-outline-primary btn-sm text-primary"
                                onClick={this.handleExportButtonClick.bind(this)}
                                href="#"
                            >
                                {__('Download XLS Export')}
                            </a>
                        </div>
                    </div>
                    <div className="card-body card-body-table pt-3 pb-3 border-top">
                        <table className="table table-borderless mb-0">
                            <thead>
                                <tr>
                                    <th scope="col" style={{ width: "190px" }}>
                                        {__('Location')}
                                    </th>
                                    <th scope="col">{__('Total')}<br />{__('Feedbacks')}</th>
                                    <th scope="col">{window.feedbackStatus.Open.label}</th>
                                    <th scope="col">{window.feedbackStatus.Pending.label}</th>
                                    <th scope="col">{window.feedbackStatus.Resolved.label}</th>
                                    <th scope="col">{window.feedbackStatus.RatingsOnly.label}</th>
                                    <th scope="col">{__('Chats')}<br />{__('Requested')}</th>
                                    <th scope="col">{__('Chats')}<br />{__('Started')}</th>
                                    <th scope="col">
                                        {__('Review')}
                                        <br />
                                        {__('Links Sent')}
                                        <br />
                                        {__('Manually')}
                                    </th>
                                    <th scope="col">
                                        {__('Clicks To')}
                                        <br />
                                        {__('Public')}
                                        <br />
                                        {__('Review')}
                                        <br />
                                        { __('Sites (Links') }
                                        <br />{ __('Sent Manually)')}
                                    </th>
                                    <th scope="col" className="smiley-rating">
                                        {__('Smiley')}<br />{__('Score')}
                                        <i
                                            className="far fa-question-circle text-muted"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-title={__("Your Smiley Score is the average of the smiley ratings selected by your customers when submitting Feedbacks. The scores range from 0% (very negative experience) to 100% (very positive experience) and are color-coded as follows") + ': <img src="/img/smiley-scale.png" style="width:100%; border-radius: 5px;" />'}
                                        ></i>
                                    </th>
                                    <th scope="col">{__('AI')}<br />{__('Sentiment')}<br />{__('Score')}
                                        <i
                                            className="far fa-question-circle text-muted"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-title={
                                                __("Feedback uses Artificial Intelligence to automatically scan Feedbacks to assess your customers' positive and negative language and emotions. The AI Sentiment Score is graded on a scale of 0% (very negative) to 100% (very positive).")
                                            }
                                        ></i>
                                    </th>
                                    <th scope="col">
                                        {__('Median')}
                                        <br />
                                        {__('Resp')}
                                        <br />
                                        {__('Time')}
                                    </th>
                                    {(this.props.businesses || this.props.business.rating_request == 1) &&
                                        <th scope="col">
                                            <img key="otf" src="/img/onethrufive-sm.png" className="feedback-list-star-logo d-inline mr-1" alt="stars" /> {__('Ratings')}
                                        </th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.totals != null && (
                                    <tr className="stats-total">
                                        <td>
                                            {this.props.business
                                                ? this.props.business.address
                                                : "All Locations"}
                                        </td>
                                        <td
                                            className="text-primary"
                                            style={{ cursor: "pointer" }}
                                            id="All"
                                            onClick={this.handleStatusClick.bind(
                                                this
                                            )}
                                        >
                                            {this.props.totals.open + this.props.totals.pending + this.props.totals.resolved}
                                        </td>
                                        <td
                                            className="text-primary"
                                            style={{ cursor: "pointer" }}
                                            id={window.feedbackStatus.Open.value}
                                            onClick={this.handleStatusClick.bind(
                                                this
                                            )}
                                        >
                                            {this.props.totals.open}
                                        </td>
                                        {this.props.totals.pending > 0 &&
                                            this.props.op && (
                                                <td
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    data-title={__('Oldest Feedback From') + ': ' + this.props.op}
                                                    className="text-primary"
                                                    style={{ cursor: "pointer" }}
                                                    id={window.feedbackStatus.Pending.value}
                                                    onClick={this.handleStatusClick.bind(this)}>
                                                    {this.props.totals.pending}{" "}
                                                    {this.props.totals.pending >
                                                        0 && (
                                                            <span className="chat-alert-message anim-pulse this.props.totals.pending > 0 and this.props.op" id={window.feedbackStatus.Pending.value}>
                                                                <i className="fas fa-exclamation-triangle text-warning mr-1" id={window.feedbackStatus.Pending.value}></i>
                                                            </span>
                                                        )}
                                                </td>
                                            )}
                                        {this.props.totals.pending < 1 && (
                                            <td
                                                className="text-primary"
                                                style={{ cursor: "pointer" }}
                                                id={window.feedbackStatus.Pending.value}
                                                onClick={this.handleStatusClick.bind(this)}
                                            >
                                                {this.props.totals.pending}{" "}
                                                {this.props.totals.pending >
                                                    0 && (
                                                        <span className="chat-alert-message anim-pulse">
                                                            <i className="fas fa-exclamation-triangle text-warning mr-1"></i>
                                                        </span>
                                                    )}
                                            </td>
                                        )}
                                        <td className="text-primary"
                                            style={{ cursor: "pointer" }}
                                            id={window.feedbackStatus.Resolved.value}
                                            onClick={this.handleStatusClick.bind(this)}>
                                            {this.props.totals.resolved}
                                        </td>
                                        <td className="text-primary"
                                            style={{ cursor: "pointer" }}
                                            id={window.feedbackStatus.RatingsOnly.value}
                                            onClick={this.handleStatusClick.bind(this)}>
                                            {this.props.totals.ratingsOnly}
                                        </td>
                                        <td className="text-primary"
                                            style={{ cursor: "pointer" }}
                                            id="chats_requested"
                                            onClick={this.handleOtherClick.bind(this)}>{this.props.totals.chats_requested}
                                        </td>
                                        <td className="text-primary" style={{ cursor: "pointer" }}>
                                            <a id="chats_started" onClick={this.handleOtherClick.bind(this)}>
                                                {this.props.totals.chats_started +
                                                    (this.props.totals.chats_requested !== 0 &&
                                                        this.props.totals.chats_started <=
                                                        this.props.totals.chats_requested ? parseInt((this.props.totals.chats_started / this.props.totals.chats_requested) * 100) !== 0 ? " (" + parseInt((this.props.totals.chats_started / this.props.totals.chats_requested) * 100) + "%)" : "" : 0)}
                                            </a>
                                            <small id="chats_waiting" onClick={this.handleOtherClick.bind(this)}>
                                                <br />({this.props.totals.chats_waiting}{' '}{__('Still Open')})
                                            </small>
                                        </td>
                                        <td className="text-primary" style={{ cursor: "pointer" }} id="links_sent" onClick={this.handleOtherClick.bind(this)}>{this.props.totals.links_sent}</td>
                                        <td style={{ cursor: "default" }} id="links_clicked">{this.props.totals.links_clicked}</td>
                                        {this.props.totals.smiley_score != null ? (
                                            <td className="d-flex" style={{ color: color, whiteSpace: "nowrap" }}>
                                                <GradedSmiley smiley_score={this.props.totals.smiley_score} />
                                                {' '}{this.props.totals.smiley_score}{' '}
                                                %
                                            </td>
                                        ) : (
                                            <td>{__('No Data')}</td>
                                        )
                                        }
                                        <td className={AIScore}>
                                            {this.props.totals.AIScore ? this.props.totals.AIScore + "%" : __("No Data")}
                                        </td>
                                        <td>
                                            {this.props.totals.median_response_time ? this.props.totals.median_response_time.formatted : __("No Data")}
                                        </td>
                                        {(this.props.businesses || this.props.business.rating_request == 1) &&
                                            <td className="text-primary" style={{ cursor: "pointer" }} id="ratethisbiz" onClick={this.handleOtherClick.bind(this)}>
                                                {this.props.totals.avg_ratethisbiz ? <span id="ratethisbiz_span">{this.props.totals.avg_ratethisbiz}<br />{getStarsJSX(this.props.totals.avg_ratethisbiz, "ratethisbiz", true)}</span> : __("No Data")}
                                            </td>
                                        }
                                    </tr>
                                )}

                                {!this.props.totals && (
                                    <tr className="stats-total">
                                        <td>{__('All Locations')}</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td>{__('No Data')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        op: state.oldest_pending ?? null,
        current_user: state.current_user ?? null,
        totals: state.totals,
        archive: state.archive,
        other_filter: state.other_filter,
        status: state.status,
        query: state.query,
        page: state.current_page,
        total: state.total_pages,
        business: state.business ?? null,
        timeframe: state.timeframe,
        feedback_id: state.selected_feedback,
        businesses: state.businesses ?? null,
        business_id: state.business
            ? state.business.business_id
            : state.feedback_detail
                ? state.feedback_detail.business_id
                : null,
        region: state.region ?? null,
        region_type: state.region_type ?? null,
        timeframe_prev: state.timeframe_prev ?? null,
        timeframe_next: state.timeframe_next ?? null,
        department_ids: state.department_ids ?? null
    };
}

export default connect(mapStateToProps)(StatsBar);
